import { render, staticRenderFns } from "./BtnDocumentoPrestacaoContasFinal.vue?vue&type=template&id=55842764&"
import script from "./BtnDocumentoPrestacaoContasFinal.vue?vue&type=script&lang=js&"
export * from "./BtnDocumentoPrestacaoContasFinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports